import { Dropdown } from 'semantic-ui-react';
import React, { useState, useEffect } from 'react';

export const EmailInput = ({ value = [], onChange }) => {
    const [options, setOptions] = useState([]);

    /* --- keep options in sync with external value --- */
    useEffect(() => {
        setOptions(prev => {
            const missing = value.filter(v => !prev.some(o => o.value === v));
            if (missing.length === 0) return prev;

            return [
                ...prev,
                ...missing.map(v => ({ key: v, text: v, value: v }))
            ];
        });
    }, [value]);
    /* ------------------------------------------------ */

    const handleAddition = (_e, { value: newEmail }) => {
        const trimmed = newEmail.trim();
        if (!trimmed || value.includes(trimmed)) return;

        setOptions(prev => [
            ...prev,
            { key: trimmed, text: trimmed, value: trimmed },
        ]);
        onChange([...value, trimmed]);
    };

    const handleChange = (_e, { value: newValue }) => {
        onChange(newValue);
    };

    return (
        <Dropdown
            placeholder="Enter email addresses"
            fluid
            multiple
            search
            selection
            allowAdditions
            style={{height: "5px"}}
            options={options}
            value={value}
            onAddItem={handleAddition}
            onChange={handleChange}
        />
    );
};
